import { render, staticRenderFns } from "./LossControlUllageReport.vue?vue&type=template&id=052b792c&scoped=true&"
import script from "./LossControlUllageReport.vue?vue&type=script&lang=js&"
export * from "./LossControlUllageReport.vue?vue&type=script&lang=js&"
import style0 from "./LossControlUllageReport.vue?vue&type=style&index=0&id=052b792c&prod&scoped=true&lang=scss&"
import style1 from "./LossControlUllageReport.vue?vue&type=style&index=1&id=052b792c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052b792c",
  null
  
)

export default component.exports